var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-4 py-2 mt-2 font-semibold border rounded",class:_vm.dynamicStyles,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }